import { makeGoalCalculator } from "./makeGoalCalculator";

export default makeGoalCalculator({
  key: "child-wedding",
  title: "Child Wedding Planning",
  description: "Plan for your child's wedding — inflate today's cost and size the monthly SIP to fund it.",
  labels: {
    presentCost: "Current cost of the wedding",
    years: "Years until child gets married",
    currentSavings: "Current savings for the wedding",
  },
  defaults: { presentCost: 20_00_000, yearsToGoal: 18 },
});
